// Centralized data-testid registry
export const HOME = {
    heroSection: "hero-section",
    heroThesis: "hero-thesis",
    heroHypothesis: "hero-hypothesis",
    heroTool: "hero-tool",
    ctaDiagnostic: "cta-diagnostic",
    tooltipPolicrise: "tooltip-policrise",
    tooltipMercadoEmergente: "tooltip-mercado-emergente",
    scrollHint: "scroll-hint",
    indicatorsSection: "indicators-section",
    indicatorItem: (k) => `indicator-${k}`,
    indicatorsUpdated: "indicators-updated-at",
    pensamentoSection: "pensamento-section",
    pensamentoItem: (slug) => `pensamento-item-${slug}`,
    footer: "footer-signature",
    footerName: "footer-author-name",
    footerPhone: "footer-author-phone",
};

export const DIAG = {
    section: "diagnostic-section",
    question: (id) => `diagnostic-question-${id}`,
    option: (qid, idx) => `diagnostic-option-${qid}-${idx}`,
    submit: "diagnostic-submit",
    reset: "diagnostic-reset",
    result: "diagnostic-result",
    resultTitle: "diagnostic-result-title",
};

export const ADMIN = {
    loginEmail: "admin-login-email",
    loginPassword: "admin-login-password",
    loginSubmit: "admin-login-submit",
    logout: "admin-logout",
    newTitle: "admin-new-title",
    newExcerpt: "admin-new-excerpt",
    newBody: "admin-new-body",
    newSubmit: "admin-new-submit",
    list: "admin-text-list",
    item: (id) => `admin-text-item-${id}`,
    deleteBtn: (id) => `admin-text-delete-${id}`,
    editBtn: (id) => `admin-text-edit-${id}`,
    saveEdit: "admin-edit-save",
    cancelEdit: "admin-edit-cancel",
};
